import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Card,
} from "@mui/material";

export default function ComingSoon({ notice = "" }) {
  const LAUNCH_DATE = "2026-03-15T00:00:00";
  const [countdown, setCountdown] = useState("00:00:00:00");

  
  useEffect(() => {
    const interval = setInterval(() => {
      const launch = new Date(LAUNCH_DATE).getTime();
      const now = Date.now();
      const diff = launch - now;

      if (diff <= 0) {
        setCountdown("00:00:00:00");
        return;
      }

      const days = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2, "0");
      const hours = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0");
      const mins = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, "0");
      const secs = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

      setCountdown(`${days}:${hours}:${mins}:${secs}`);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #001f3f, #003366, #0b2a4a)",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 3,
        textAlign: "center",
      }}
    >
      <Card
        sx={{
          p: 4,
          borderRadius: 3,
          maxWidth: 500,
          width: "100%",
          background: "rgba(255, 255, 255, 0.08)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        
        <Typography variant="h4" fontWeight={800} sx={{ mb: 1 }}>
          🎉 Coming Soon
        </Typography>

        <Typography sx={{ opacity: 0.8, mb: 3 }}>
          {notice || "Something amazing is loading…  We’re launching very soon!"}
        </Typography>

        
        <Typography
          variant="h3"
          fontWeight={800}
          sx={{ letterSpacing: 2, mb: 3, color: "#fbc02d" }}
        >
          {countdown}
        </Typography>

        <Typography sx={{ fontSize: 14, opacity: 0.7, mb: 3 }}>
          Days : Hours : Minutes : Seconds
        </Typography>

        
        <Stack spacing={2}>
          <TextField
            placeholder="Enter your email"
            variant="outlined"
            fullWidth
            sx={{
              input: { color: "white" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#fbc02d" },
                "&:hover fieldset": { borderColor: "#ffd54f" },
                "&.Mui-focused fieldset": { borderColor: "#fbc02d" },
              },
              "& .MuiInputLabel-root": { color: "#fbc02d" },
            }}
          />

          <Button
            variant="contained"
            fullWidth
            sx={{
              bgcolor: "#fbc02d",
              color: "#001f3f",
              fontWeight: 700,
              py: 1.4,
              borderRadius: 2,
              "&:hover": { bgcolor: "#ffca28" },
            }}
          >
            Notify Me
          </Button>
        </Stack>
      </Card>
    </Box>
  );
}
